import React from 'react';

const LoadingChart = () => {
  return (
    <div className="h-screen w-screen m-1 flex items-center justify-center bg-[#101523]">
      <div className="animate-pulse flex flex-col items-center">
        <div className="w-32 h-32 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>
        <p className="mt-4 text-lg text-white">Cargando gráfico...</p>
      </div>
    </div>
  );
};

export default LoadingChart; 